import React, { Component } from "react";
import { Form, Button, Message, Icon, Modal, Divider, Checkbox } from 'semantic-ui-react'
import { invokeApig } from "../libs/awsLib";
import XMLDataEntry from './XMLDataEntry'
import LoadingPage from "./LoadingPage"
export default class SmartServiceRequestModal extends Component {
  constructor(props) {
    super(props);
    this.state=this.defaultState;
    this.state={srdefinition: {}, isSRLoaded: false, data:{}, submitFailed: false, submitSuccess: false, validationErrors: [], validationWarnings: [], isExecuting: false,sendtodevice: true, returnforlocaldelivery: false, xmlbody: ''};
  }
  


  loadServiceRequest=(srv)=>{
    //get function definition    
    invokeApig({path: "/smart/servicerequests/" + srv, method: "GET",  body: null}).then((result)=>{
        this.setState({srdefinition: result.data, isSRLoaded: true});
        });
        

  }

  async componentDidMount() {
    // this.setState(this.defaultState);
    const srv=this.props.servicereferencevariant;
    if(srv) this.loadServiceRequest(srv);
      
  }

  async componentWillReceiveProps(nextProps) {

    if (!(nextProps.servicereferencevariant === this.props.servicereferencevariant) && nextProps.servicereferencevariant !== null) 
    {
      this.setState({isSRLoaded: false, submitFailed: false, submitSuccess: false, validationErrors: [], validationWarnings: [], isExecuting: false,sendtodevice: true, returnforlocaldelivery: false, xmlbody: ''})
      const srv=nextProps.servicereferencevariant;
      if(srv) this.loadServiceRequest(srv);
    } 
  }

sendServiceRequest=async event => {
  if(event) event.preventDefault();
  this.setState({submitFailed:false, submitSuccess: false, validationErrors: []});
  try
  {
    const requestBody={sendtodevice: this.state.sendtodevice, returnforlocaldelivery: this.state.returnforlocaldelivery, xmlbody: this.state.xmlbody}
    var result=await invokeApig({path: '/smart/smartdevices/'+this.props.parententityid+'/servicerequests/'+this.props.servicereferencevariant, method: "POST",  body: requestBody});
    if(result.status===200 || result.status===201) 
      {
        if ('warnings' in result.data)
        {
          this.setState({submitSuccess: true, isExecuting: false, validationWarnings: result.data.warnings})
        }
        else
        {
          this.setState({submitSuccess: true, isExecuting: false, validationWarnings: []})
        }
    //  this.props.closefunctionmodal(true)
    }  
    else if(result.status===400) 
    {this.setState({submitFailed: true, validationErrors: result.data, isExecuting: false})}
    else if(result.status===401) 
    {this.setState({submitFailed: true, validationErrors: ['You are not authorised to perform this action'], isExecuting: false})}
    else if(result.status===404) 
    {this.setState({submitFailed: true, validationErrors: ['API endpoint not found'], isExecuting: false})}
    else if(result.status===502) 
    {this.setState({submitFailed: true, validationErrors: ['An error occurred executing the API request'], isExecuting: false})}
    else
    {this.setState({submitFailed: true, validationErrors: ['Unrecognised error code ' + result.status], isExecuting: false})}      
  }
  catch (e)
  {
    this.setState({submitFailed: true, validationErrors: ['An error occurred submitting the request'], isSubmitting: false})
  }
}

updateData=(value)=>
{
 this.setState({xmlbody: value})
}

closeButtonClicked=()=>{
  //this.resetState()
  this.setState(this.defaultState);
  this.props.closefunctionmodal(this.state.submitSuccess)

}


  render() {
      const modalStyle = {
      modal : {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
      }
    };
    return (
     
        <Modal style={modalStyle.modal} open={this.props.visible}>
        <Modal.Header size='tiny'>
          <h3 className="seaglassblue"><Icon circular className="seaglassblue" name="graduation"/>{this.state.srdefinition.servicereferencevariant+ ' '+this.state.srdefinition.description}</h3>
        </Modal.Header>  
        <Modal.Content>
        {this.state.isSRLoaded ? 
        <Form>
        <XMLDataEntry jsonformat={this.state.srdefinition.jsontemplate} namespace={this.state.srdefinition.xmlnamespace} data={this.state.data} editmode={true} onDataChange={newData=>{this.updateData(newData)}} />
        {!this.state.srdefinition.nondevicerequest && <Checkbox label={'Send to device'} checked={this.state.sendtodevice} onChange={(event, data)=>{this.setState({sendtodevice: data.checked})}}/>}
        {!this.state.srdefinition.nondevicerequest && <Checkbox label={'Return for local delivery'} checked={this.state.returnforlocaldelivery} onChange={(event, data)=>{this.setState({returnforlocaldelivery: data.checked})}}/>}
        <Message
          success
          visible={this.state.submitSuccess}
          header={this.state.validationWarnings.length>0 ? "Action Completed With Warnings" : "Action Completed Successfully"}
          list={this.state.validationWarnings}
        />
        <Message
          error
          visible={this.state.submitFailed}
          header="Action Failed"
          list={this.state.validationErrors}
        />
        <Divider/>
        <Button className="seaglassbutton" disabled={this.state.submitSuccess} loading={this.state.isExecuting} onClick={this.sendServiceRequest}>Send</Button>
        <Button className="seaglassbutton" onClick={this.closeButtonClicked}>Close</Button>
        </Form>
        :
        <LoadingPage/>}
        </Modal.Content>
        </Modal>   
      
    );
  }
}